import { EntityUpdateUnion } from 'api' /* Define the run-time values */

/* Define the run-time values */

const EntityType = {
  APPLICATION_ALERT: 'APPLICATION_ALERT' as const,
  AXE: 'AXE' as const,
  AUTHORISED_USER: 'AUTHORISED_USER' as const,
  CLEARING_HOUSE: 'CLEARING_HOUSE' as const,
  BATCH_DATA: 'BATCH_DATA' as const,
  BEST_PRICE: 'BEST_PRICE' as const,
  CLEARING_HOUSE_INTERACTION: 'CLEARING_HOUSE_INTERACTION' as const,
  COLLATERAL: 'COLLATERAL' as const,
  COLLATERAL_DETAILS: 'COLLATERAL_DETAILS' as const,
  COLLATERAL_PRICE: 'COLLATERAL_PRICE' as const,
  COLLATERAL_BASKET: 'COLLATERAL_BASKET' as const,
  COLLATERAL_UPLOAD: 'COLLATERAL_UPLOAD' as const,
  COLLATERAL_REFINITIV_IMPORT_RESULT: 'COLLATERAL_REFINITIV_IMPORT_RESULT' as const,
  COLLECTION: 'COLLECTION' as const,
  COMPLIANCE_COLLATERAL: 'COMPLIANCE_COLLATERAL' as const,
  COUNTER: 'COUNTER' as const,
  COUNTRY: 'COUNTRY' as const,
  CLUSTER_PONG: 'CLUSTER_PONG' as const,
  CLUSTER_CLIENT_STATE: 'CLUSTER_CLIENT_STATE' as const,
  CLUSTER_SESSION: 'CLUSTER_SESSION' as const,
  DATABASE_REPORT_REQUEST: 'DATABASE_REPORT_REQUEST' as const,
  DEAL: 'DEAL' as const,
  DEAL_HISTORY: 'DEAL_HISTORY' as const,
  DEAL_INTEREST_PERIOD: 'DEAL_INTEREST_PERIOD' as const,
  DEV_SIGNAL: 'DEV_SIGNAL' as const,
  EGRESS_POSITION: `EGRESS_POSITION` as const,
  EONIA_RATE: `EONIA_RATE` as const,
  ESTR_RATE: `ESTR_RATE` as const,
  FAT_FINGER_PRODUCT_SECTOR: 'FAT_FINGER_PRODUCT_SECTOR' as const,
  FAT_FINGER_USER: 'FAT_FINGER_USER' as const,
  FX_RATE: 'FX_RATE' as const,
  HAIRCUT_BAND: 'HAIRCUT_BAND' as const,
  HAIRCUT_COLLATERAL_BAND: 'HAIRCUT_COLLATERAL_BAND' as const,
  HAIRCUT_ENTRY: 'HAIRCUT_ENTRY' as const,
  HOLIDAY: 'HOLIDAY' as const,
  INDEX: 'INDEX' as const,
  IN_FLIGHT_ORGANISATION: 'IN_FLIGHT_ORGANISATION' as const,
  IN_FLIGHT_TARGET_ORGANISATION: 'IN_FLIGHT_TARGET_ORGANISATION' as const,
  IMPORT_COMPLETE: 'IMPORT_COMPLETE' as const,
  NEGOTIATION: 'NEGOTIATION' as const,
  NEGOTIATION_AGGREGATE: 'NEGOTIATION_AGGREGATE' as const,
  NEGOTIATION_OVERRIDE: 'NEGOTIATION_OVERRIDE' as const,
  NEGOTIATION_HISTORY: 'NEGOTIATION_HISTORY' as const,
  NOTES: 'NOTES' as const,
  ORDER: 'ORDER' as const,
  ORDER_RECORD_KEEPING: 'ORDER_RECORD_KEEPING' as const,
  ORGANISATION: 'ORGANISATION' as const,
  ISSUER_ORGANISATION: 'ISSUER_ORGANISATION' as const,
  ORGANISATION_META: 'ORGANISATION_META' as const,
  PERMISSION_REPORT_REQUEST: 'PERMISSION_REPORT_REQUEST' as const,
  PLATFORM: 'PLATFORM' as const,
  PRIME_BROKER: 'PRIME_BROKER' as const,
  PRODUCT: 'PRODUCT' as const,
  PRODUCT_SECTOR: 'PRODUCT_SECTOR' as const,
  PRODUCT_SECTOR_MAPPING: 'PRODUCT_SECTOR_MAPPING' as const,
  PRODUCT_SECTOR_MAPPING_DRAFT: 'PRODUCT_SECTOR_MAPPING_DRAFT' as const,
  PRODUCT_SECTOR_MAPPING_STATE: 'PRODUCT_SECTOR_MAPPING_STATE' as const,
  REFERENCE_DATA_MANAGEMENT_DATA: 'REFERENCE_DATA_MANAGEMENT_DATA' as const,
  REFERENCE_RATE: 'REFERENCE_RATE' as const,
  RETRY_FAILED_EXPORT: 'RETRY_FAILED_EXPORT' as const,
  RESET_SOTW: 'RESET_SOTW' as const,
  SOTW_SENT: 'SOTW_SENT' as const,
  SPONSOR: 'SPONSOR' as const,
  SPREADSHEET_MAPPING: 'SPREADSHEET_MAPPING' as const,
  TRADING_CONTROL_LIMIT: 'TRADING_CONTROL_LIMIT' as const,
  TRADING_CONTROL_LIMIT_USER_UTILISATION: 'TRADING_CONTROL_LIMIT_USER_UTILISATION' as const,
  TRADING_ENTITY: 'TRADING_ENTITY' as const,
  TRADING_ENTITY_ALIAS: 'TRADING_ENTITY_ALIAS' as const,
  TRADING_ENTITY_CLEARING: 'TRADING_ENTITY_CLEARING' as const,
  TRADING_ENTITY_META: 'TRADING_ENTITY_META' as const,
  TRADING_RELATIONSHIP: 'TRADING_RELATIONSHIP' as const,
  USER: 'USER' as const,
  UPDATE_COLLATERALS_REQUEST: 'UPDATE_COLLATERALS_REQUEST' as const,
  UPDATE_ISSUER_ORGANISATION_REQUEST: 'UPDATE_ISSUER_ORGANISATION_REQUEST' as const,
  USER_PREFERENCE: 'USER_PREFERENCE' as const,
  USER_SETTINGS: 'USER_SETTINGS' as const,
  WORKING_DAYS: 'WORKING_DAYS' as const,
  AUDIT_ENTRY: 'AUDIT_ENTRY' as const,
  DEAL_EXPORT: 'DEAL_EXPORT' as const,
  QUERY_REQUEST: 'QUERY_REQUEST' as const
}

/* Define the union type */
type EntityType = EntityUpdateUnion['entityType']

export { EntityType }
